import React, { Fragment } from "react";
import { Button, Table } from "reactstrap";
import {
  Archivo,
  AutorizacionMedicaEncuesta,
  StatusAutorizacion
} from "../types";
import s from "./styles.scss";
import { ReduxConnect, Styled } from "../../../../toolkit/decorators/Artifact";
import { formatIsoDate } from "../../../helpers/formatters";
import { dacInfoDispatcher, DacInfoDispatcher } from "./dacInfo.dispatcher";
import { dacInfoStore, DacInfoStore } from "./dacInfo.store";
import { successNotification } from "../../../../utils/notifications";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import { userHasPermission } from "../../../../utils/accessTree";

interface Props extends DacInfoStore, DacInfoDispatcher {
  // Archivo que contiene las encuestas
  archivo: Archivo;
  encuestas: AutorizacionMedicaEncuesta[];

  // Se invoca después de ignorar la autorización médica
  onIgnored?: () => any;
}

interface State {
  confirmOpen: boolean;
}

@ReduxConnect(dacInfoStore, dacInfoDispatcher)
@Styled(s)
export default class DACInfo extends React.Component<Props, State> {
  state: Readonly<State> = {
    confirmOpen: false
  };

  ignorar = async () => {
    const { archivo, onIgnored } = this.props;

    const preview = await this.props.deleteAutorizacionMedica(
      archivo.idExpediente,
      archivo.codigo
    );

    this.setState({ confirmOpen: false });

    if (preview.fulfilled) {
      successNotification("Autorización médica ignorada correctamente");
      onIgnored && onIgnored();
    }
  };

  exclusionValida = () => {
    const { archivo, encuestas } = this.props;

    if (!archivo || !encuestas || encuestas.length === 0) {
      return false;
    }

    if (archivo.statusAutorizacion != StatusAutorizacion.NO_AUTORIZADO) {
      return false;
    }

    if (
      userHasPermission(56106) &&
      archivo.codigo == "TP_AUTORIZACION_MEDICA"
    ) {
      return true;
    }

    return false;
  };

  render() {
    const { encuestas, ignorandoAutorizacionMedica } = this.props;

    if (!encuestas || encuestas.length === 0) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          No hay encuestas de antecedentes clínicos disponibles
        </div>
      );
    }

    return (
      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
        {encuestas.map((encuesta, index) => (
          <Fragment key={`${encuesta.idPersonaEvaluacion}-${index}`}>
            <Table bordered size="sm" className="mb-4">
              <thead className="thead-light">
                <tr>
                  <th>
                    Fecha de respuestas:{" "}
                    {formatIsoDate(encuesta.fechaRespuesta)}
                  </th>
                </tr>
              </thead>
              <tbody>
                {encuesta.respuestasAfirmativas.map((pregunta, index) => (
                  <tr>
                    <td key={index}>{pregunta.pregunta}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Fragment>
        ))}

        {this.exclusionValida() && (
          <div className="text-right">
            <Button
              color="danger"
              disabled={ignorandoAutorizacionMedica}
              onClick={() => this.setState({ confirmOpen: true })}
            >
              Excluir autorización médica
            </Button>
          </div>
        )}

        <ConfirmModal
          isOpen={this.state.confirmOpen}
          title="Excluir autorización médica"
          message="¿Desea excluir la autorización médica? Esta acción no se puede deshacer."
          waiting={ignorandoAutorizacionMedica}
          ok={this.ignorar}
          cancel={() => this.setState({ confirmOpen: false })}
          size="md"
        />
      </div>
    );
  }
}
